/* =============================================================
   ARGOING REV18 - Blocco 2 "Prestazioni" (30-10-2026)
   Un solo file, caricato con defer da snippets/argoing-rev18-perf.liquid.
   1. Slide della home: le foto delle slide 2..N stanno in data-ag-src / data-ag-srcset
      e vengono caricate quando la slide diventa attiva, successiva o precedente
      (Swiper aggiunge le classi swiper-slide-active / -next / -prev). Rete di
      sicurezza: se Swiper non parte entro 6 s dal load si caricano tutte.
   2. Widget eShoppingAdvisor: gli <script src="https://badge.eshoppingadvisor.com/...">
      scritti nelle sezioni "Liquid personalizzato" vengono trasformati dal tema in
      <script type="text/ag-lazy" data-src="..."> e attivati qui: quando il riquadro
      si avvicina allo schermo (400 px), alla prima interazione dell'utente, oppure
      in idle dopo il load (max 3 s). Il widget resta sempre visibile.
   Per disattivare tutto: togliere il render di 'argoing-rev18-perf' da snippets/head.is-land.liquid
   e rimettere ag_defer = false in snippets/section.slideshow.slide.liquid.
   ============================================================= */
(function () {
  'use strict';
  var W = window, D = document;
  var designMode = !!(W.Shopify && W.Shopify.designMode);

  function idle(fn, timeout) {
    if (W.requestIdleCallback) W.requestIdleCallback(fn, { timeout: timeout || 3000 });
    else setTimeout(fn, Math.min(timeout || 3000, 1500));
  }
  function afterLoad(fn) {
    if (D.readyState === 'complete') fn();
    else W.addEventListener('load', fn, { once: true });
  }
  function onFirstInteraction(fn) {
    var evs = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'];
    var done = false;
    function h() {
      if (done) return;
      done = true;
      evs.forEach(function (e) { W.removeEventListener(e, h, true); });
      fn();
    }
    evs.forEach(function (e) { W.addEventListener(e, h, { capture: true, passive: true }); });
  }

  /* ---------- 1. slide differite ---------- */
  function hydrateSlide(slide) {
    if (!slide || slide.getAttribute('data-ag-ready') === '1') return;
    slide.setAttribute('data-ag-ready', '1');
    var els = slide.querySelectorAll('[data-ag-srcset],[data-ag-src]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var ss = el.getAttribute('data-ag-srcset');
      var s = el.getAttribute('data-ag-src');
      if (ss) { el.setAttribute('srcset', ss); el.removeAttribute('data-ag-srcset'); }
      if (s) { el.setAttribute('src', s); el.removeAttribute('data-ag-src'); }
      el.classList.remove('slideshow-slide__image--ag-defer');
    }
  }
  function hydrateAll(root) {
    var slides = (root || D).querySelectorAll('[data-slideshow-slide]');
    for (var i = 0; i < slides.length; i++) hydrateSlide(slides[i]);
  }
  function hydrateNeighbours(root) {
    var sel = '.swiper-slide-active, .swiper-slide-next, .swiper-slide-prev, .slide--active';
    var slides = root.querySelectorAll(sel);
    for (var i = 0; i < slides.length; i++) hydrateSlide(slides[i]);
  }
  function watchSlideshow(el) {
    if (el.getAttribute('data-ag-watch') === '1') return;
    el.setAttribute('data-ag-watch', '1');
    if (designMode) { hydrateAll(el); return; }
    hydrateNeighbours(el);
    if (W.MutationObserver) {
      var mo = new MutationObserver(function () { hydrateNeighbours(el); });
      mo.observe(el, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    // chi tocca o passa sopra la slideshow vuole scorrere: carichiamo le vicine subito
    el.addEventListener('pointerdown', function () { hydrateNeighbours(el); }, { passive: true });
    el.addEventListener('touchstart', function () { hydrateNeighbours(el); }, { passive: true });
    // rete di sicurezza: senza Swiper (JS del tema fallito) tutte le foto entro 6 s dal load
    afterLoad(function () {
      setTimeout(function () {
        var wrap = el.querySelector('[data-slideshow-wrapper]');
        if (!wrap || !wrap.classList.contains('swiper-initialized')) hydrateAll(el);
      }, 6000);
    });
  }
  function initSlides() {
    var shows = D.querySelectorAll('section-slideshow, .slideshow--section');
    for (var i = 0; i < shows.length; i++) watchSlideshow(shows[i]);
    // slide differite fuori da una section-slideshow (caso anomalo): si caricano a vista
    if (W.IntersectionObserver) {
      var orphans = D.querySelectorAll('[data-slideshow-slide]:not([data-ag-ready])');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { hydrateSlide(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '200px 0px' });
      for (var j = 0; j < orphans.length; j++) {
        if (!orphans[j].closest('section-slideshow, .slideshow--section')) io.observe(orphans[j]);
      }
    }
  }

  /* ---------- 2. script terzi differiti (eShoppingAdvisor) ---------- */
  function activateLazyScript(s) {
    if (s.getAttribute('data-ag-done') === '1') return;
    s.setAttribute('data-ag-done', '1');
    var n = D.createElement('script');
    n.src = s.getAttribute('data-src');
    n.async = true;
    s.parentNode.insertBefore(n, s.nextSibling);
  }
  function initLazyScripts() {
    var list = D.querySelectorAll('script[type="text/ag-lazy"][data-src]');
    if (!list.length) return;
    function all() { for (var i = 0; i < list.length; i++) activateLazyScript(list[i]); }
    if (designMode) { all(); return; }
    if (W.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var sc = e.target.querySelectorAll('script[type="text/ag-lazy"][data-src]');
          for (var i = 0; i < sc.length; i++) activateLazyScript(sc[i]);
          io.unobserve(e.target);
        });
      }, { rootMargin: '400px 0px' });
      for (var i = 0; i < list.length; i++) io.observe(list[i].parentNode || list[i]);
    }
    onFirstInteraction(all);
    afterLoad(function () { idle(all, 3000); });
  }

  function start() {
    try { initSlides(); } catch (e) { try { hydrateAll(); } catch (e2) {} }
    try { initLazyScripts(); } catch (e) {}
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start);
  else start();
  // sezioni ricaricate dall'editor del tema
  D.addEventListener('shopify:section:load', function () { try { initSlides(); initLazyScripts(); } catch (e) {} });
})();
